import * as userAccounts from './userAccounts';
import * as utility from './utility';

let $ = require( 'jquery' );

export function initializeChallengeLevel(scene)
{
	console.log("this is", this);
    setWinCondition(scene, scene.levelData.metric, scene.levelData.goal, scene.levelData.goal2);
    if (scene.levelData.metric == 'workers')
    {
        createNumberOfWorkersLeaderboard(scene);
        var spawnNewQueensWhenNeededEvent = scene.time.addEvent(
        {
            delay: scene.queenSpawnRate,
            callback: scene.spawnNewQueensWhenNeeded,
            callbackScope: scene,
            loop: true
        });
    }
    if (scene.levelData.metric == 'yellowjackets')
    {
        createNumberOfYellowjacketsLeaderboard(scene);
        scene.yellowJacketSpawner();
    }

    if (scene.levelData.metric == 'giantWasps')
    {
        createNumberOfGiantWaspsLeaderboard(scene);
    }

    if (scene.levelData.metric == 'wasps')
    {
        scene.yellowJacketSpawner();
        createNumberOfYellowjacketsLeaderboard(scene);
        tallyNumberOfYellowjacketsScores(scene);
        createNumberOfGiantWaspsLeaderboard(scene);
    }

    if (scene.levelData.metric == 'queenBees')
    {
        createNumberOfQueenBeesLeaderboard(scene);
    }
}

export function setWinCondition(scene, metric, goal, goal2)
{
    console.log('Player will win when they have', goal, metric, '.');
    scene.metric = metric;
    scene.goal = goal;
    if (goal2)
    {
        scene.goal2 = goal2;
    }
}

export function checkForWinOrLoss(scene, score, isPlayerScore, score2)
{
    try {
        if (scene.challengeConcluded == false)
        {
            switch(scene.metric)
            {
                case 'workers':
                    if (score >= scene.goal)
                    {
                        if (isPlayerScore)
                        {
                            challengeWin(scene);
                        } else {
                            challengeLoss(scene);
                        }
                    }
                    break;
                case 'yellowjackets':
                    if (score == scene.goal && scene.yellowJackets.length != 0)
                    {
                        scene.createYellowJacketEvent.remove(false);
                        challengeWin(scene);
                    }
                    break;
                case 'wasps':
                    if (scene.score == scene.goal &&
                        scene.score2 == scene.goal2)
                    {
                        challengeWin(scene);
                    }
                default:
                    if (score == scene.goal)
                    {
                        challengeWin(scene);
                    }
                    break;
            }
        }
    } catch(e) {
    	console.log('There was an error checking for win or loss: ', e);
    }
}

export function challengeWin(scene)
{
    try {
        console.log('Challenge win!');
        scene.challengeConcluded = true;
        scene.challengeFail = false;
        userAccounts.addHoneyToUserAccount(scene, scene.levelData.reward);

        // Store level unlocked for later.
        let levelUnlocked = localStorage.getItem('levelUnlocked');
        if (!levelUnlocked || Number(levelUnlocked) <= scene.level)
        {
            if (!levelUnlocked)
            {
                levelUnlocked = 2;
            } else {
                levelUnlocked = Number(scene.level)+1;
            }
            localStorage.setItem('levelUnlocked', levelUnlocked);
            userAccounts.addUnlockedLevelToUserAccount(scene, levelUnlocked);
        }

        document.getElementById('winLossText').innerHTML = 'Challenge success!';
        let honeyEarnedTextContent = '+<img src="src/assets/individualImages/honeyIcon.png" alt="Honey">';
        honeyEarnedTextContent += scene.levelData.reward;
        document.getElementById('honeyEarnedText').innerHTML = honeyEarnedTextContent;
        document.getElementById('continuePlayingButton').hidden = false;
        document.getElementById('winLossOr').hidden = false;
        document.getElementById('continuePlayingRow').hidden = false;
        document.getElementById('nextLevelButton').innerHTML = '<i class="fa fa-arrow-right"></i><br>Next Level';
        $('#winLossModal').modal({backdrop: 'static'});
    } catch (e) {
        console.log('There was an error on challenge win.', e);
    }
}

export function challengeLoss(scene)
{
    try {
        console.log('Challenge loss.');
        scene.challengeConcluded = true;
        scene.challengeFail = true;
        document.getElementById('winLossText').innerHTML = 'Challenge failed. Sorry, that stings.';
        document.getElementById('honeyEarnedText').innerHTML = '';
        document.getElementById('continuePlayingButton').hidden = false;
        document.getElementById('continuePlayingRow').hidden = false;
        document.getElementById('winLossOr').hidden = false;
        document.getElementById('nextLevelButton').innerHTML = '<i class="fa fa-redo fa-1x"></i><br>Try Again';
        $('#winLossModal').modal({backdrop: 'static'});
    } catch (e) {
        console.log('There was an error on challenge loss.', e);
    }
}

export function loadChallengeSetup(scene)
{
    console.log('Loading challenge setup...');
    switch(scene.level)
    {
        case 2:
            this.numberOfStarterWorkers = 3;
            this.numberOfQueenBeeBots = 0;
            this.numberOfGreenSpaces = 5;
            this.numberOfLogs = 3;
            this.numberOfBoulders = 3;
            this.numberOfPonds = 1;
            this.numberOfTrees = 5;
            this.numberOfStarterHives = 3;
            this.yellowJacketSpawnRate = (1000 * 60) * 1000000;
            // this.waspSpawnRate = 1;
            this.waspSpawnRate =         (1000 * 60) * 5000000;
            break;
        default:
            this.numberOfStarterWorkers = 3;
            this.numberOfQueenBeeBots = 0;
            this.numberOfGreenSpaces = 8;
            this.numberOfLogs = 2;
            this.numberOfBoulders = 4;
            this.numberOfPonds = 2;
            this.numberOfTrees = 2;
            this.numberOfStarterHives = 1;
            this.yellowJacketSpawnRate = (1000 * 60) * 3000000;
            this.waspSpawnRate =         (1000 * 60) * 5000000;
            break;
    }

    if (scene.levelData.numberOfQueenBeeBots)
    {
        scene.numberOfQueenBeeBots = scene.levelData.numberOfQueenBeeBots;
    }

    if (scene.levelData.numberOfYellowJackets)
    {
        scene.numberOfStarterYellowJackets = scene.levelData.numberOfYellowJackets;
    }

    if (scene.levelData.numberOfGiantWasps)
    {
        scene.numberOfStarterGiantWasps = scene.levelData.numberOfGiantWasps;
    }
}

export function spawnNewQueensWhenNeeded()
{
    // Check if all queen bee bots are dead.
    let numberOfLivingQueenBeeBots = 0;
    this.queenBees.forEach(function(queenBee, i)
    {
        if (queenBee.queenBeeSprite.active && queenBee.isBot)
        {
            numberOfLivingQueenBeeBots++;
        }
    });

    if (numberOfLivingQueenBeeBots == 0)
    {
        let botUserName = 'Bot' + this.queenBees.length;
        let botColonyName = 'Bot' + this.queenBees.length;
        let botSpecies = this.pickARandomBeeSpecies(this);
        let randomX = Phaser.Math.RND.integerInRange(-600, 600);
        let randomY = Phaser.Math.RND.integerInRange(-600, 600);
        console.log('Spawning new queen bee bot since they all died.');
        utility.spawnQueenBeeBot(this, randomX, randomY, botUserName, botColonyName, botSpecies);
        this.createNumberOfWorkersLeaderboard(this);
    } else {
        console.log('No new queen bee bots needed.');
    }

    // Update leaderboard with new queen.
}

export function createNumberOfWorkersLeaderboard(scene)
{
    try {

        if (scene.workerCountSprites.length == 0)
        {
            console.log('Creating number of workers leaderboard.');

            var y = 90;

            tallyNumberOfWorkerScores(scene);

            scene.queenBees.forEach(function(queenBee, i)
            {
                if (queenBee.queenBeeSprite.active)
                {
                    // Create the score background.
                    scene.workerCountSprites[i] = scene.add.sprite(0, y, 'sprites', 'workerCount.png')
                        .setScrollFactor(0)
                        .setOrigin(0)
                        .setAlpha(0.5);
                    scene.workerCountSprites[i].x = window.innerWidth - scene.workerCountSprites[i].width - 25;
                    scene.workerCountSprites[i].username = queenBee.username;
                    scene.uiGroup.add(scene.workerCountSprites[i]);
                    // Create score text
                    scene.scoreTexts[i] = scene.add.text(scene.workerCountSprites[i].x + (scene.workerCountSprites[i].width/2), scene.workerCountSprites[i].y + 15, queenBee.numberOfWorkers)
                        .setScrollFactor(0)
                        .setOrigin(0.5)
                        .setFontFamily('Arial')
                        .setFontSize(24)
                        .setColor('#F0DB87')
                        .setAlpha(0.95);
                    scene.scoreTexts[i].username = queenBee.username;
                    scene.uiGroup.add(scene.scoreTexts[i]);

                    // Nametag
                    let leaderboardUsernameText;

                    if (i == 0)
                    {
                        leaderboardUsernameText = 'You';
                    } else {
                        switch(queenBee.species)
                        {
                            case 'mellifera':
                                leaderboardUsernameText = 'Honey Bee';
                                break;
                            case 'violetBee':
                                leaderboardUsernameText = 'Violet';
                                break;
                            case 'blueBee':
                                leaderboardUsernameText = 'Blue';
                                break;
                            case 'sweat':
                                leaderboardUsernameText = 'Sweat Bee';
                                break;
                            case 'bumbleBee':
                                leaderboardUsernameText = 'Bumble Bee';
                                break;
                            case 'catBee':
                                leaderboardUsernameText = 'Cat';
                                break;
                            case 'crown':
                                leaderboardUsernameText = 'Crown';
                                break;
                            case 'threeCorneredHat':
                                leaderboardUsernameText = 'Three-Cornered Hat';
                                break;
                            case 'fedora':
                                leaderboardUsernameText = 'Fedora';
                                break;
                            case 'partyHat':
                                leaderboardUsernameText = 'Party';
                                break;
                            case 'horns':
                                leaderboardUsernameText = 'Horns';
                                break;
                            case 'gasMask':
                                leaderboardUsernameText = 'Gas Mask';
                                break;
							case 'wizardHat':
								leaderboardUsernameText = "Wizard Hat"
								break;
				            case 'knight':
								leaderboardUsernameText = "Knight"
								break;
                            default:
                                console.log('A bee skin is missing leaderboard username text.');
                        }
                    }
                    scene.scoreUsernameTexts[i] = scene.add.text(scene.scoreTexts[i].x - 50, scene.workerCountSprites[i].y + 15, leaderboardUsernameText)
                        .setScrollFactor(0)
                        .setOrigin(1, 0.5)
                        .setFontFamily('Arial')
                        .setFontSize(16)
                        .setColor('#7695B0')
                        .setStroke('#3c2040', 3)
                        .setAlpha(0.95);
                    scene.scoreUsernameTexts[i].username = queenBee.username;
                    scene.uiGroup.add(scene.scoreUsernameTexts[i]);
                    // Set color of our own text to yellow.
                    // if (queenBee.username == client.username)
                    // {
                    //     scene.scoreUsernameTexts[i].setColor('#F0DB87');
                    // }

                    y += 50;

                } else {
                    console.log("A queen wasn't active. Skipping it.");
                }

            });

            utility.setDepthOfGroups(scene);

            scene.minimapCamera.ignore(scene.uiGroup);

        } else {
            console.log('Number of workers leaderboard already existed. Removing and rebuilding it...');

            scene.workerCountSprites.forEach(function(workerCountSprite, i)
            {
                workerCountSprite.destroy();
                scene.scoreUsernameTexts[i].destroy();
                scene.scoreTexts[i].destroy();
            });
            scene.workerCountSprites = [];
            scene.createNumberOfWorkersLeaderboard(scene);
        }
    } catch(e) {
    	console.log('There was an error creating number of workers leaderboard: ', e);
    }
}

export function createNumberOfYellowjacketsLeaderboard(scene)
{
    try {
        console.log('Creating number of yellowjackets leaderboard.');
        scene.numberOfYellowjackets = 0;
        var y = 90;

        tallyNumberOfYellowjacketsScores(scene);

        // Create the score background.
        scene.yellowJacketCountSprite = scene.add.sprite(0, y, 'sprites', 'yellowjacketCount.png')
            .setScrollFactor(0)
            .setOrigin(0)
            .setAlpha(0.5);
        scene.yellowJacketCountSprite.x = window.innerWidth - scene.yellowJacketCountSprite.width - 25;
        scene.uiGroup.add(scene.yellowJacketCountSprite);
        // Create score text
        scene.yellowJacketScoreText = scene.add.text(scene.yellowJacketCountSprite.x + (scene.yellowJacketCountSprite.width/2), scene.yellowJacketCountSprite.y + 15, scene.numberOfYellowjackets)
            .setScrollFactor(0)
            .setOrigin(0.5)
            .setFontFamily('Arial')
            .setFontSize(24)
            .setColor('#F0DB87')
            .setAlpha(0.95);
        scene.uiGroup.add(scene.yellowJacketScoreText);

        utility.setDepthOfGroups(scene);

        scene.minimapCamera.ignore(scene.uiGroup);
    } catch(e) {
    	console.log('There was an error creating number of yellow jackets leaderboard: ', e);
    }
}

export function createNumberOfGiantWaspsLeaderboard(scene)
{
    try {
        console.log('Creating number of giant wasps leaderboard.');

        let y = 90;
        if (scene.yellowJacketCountSprite)
        {
            y += scene.yellowJacketCountSprite.y - scene.yellowJacketCountSprite.height + 25;
        }

        tallyNumberOfGiantWasps(scene);

        // Create the score background.
        scene.giantWaspCountSprite = scene.add.sprite(0, y, 'sprites', 'giantWaspCount.png')
            .setScrollFactor(0)
            .setOrigin(0)
            .setAlpha(0.5);
        scene.giantWaspCountSprite.x = window.innerWidth - scene.giantWaspCountSprite.width - 25;
        scene.uiGroup.add(scene.giantWaspCountSprite);
        // Create score text
        scene.giantWaspScoreText = scene.add.text(scene.giantWaspCountSprite.x + (scene.giantWaspCountSprite.width/2), scene.giantWaspCountSprite.y + 15, scene.numberOfGiantWasps)
            .setScrollFactor(0)
            .setOrigin(0.5)
            .setFontFamily('Arial')
            .setFontSize(24)
            .setColor('#F0DB87')
            .setAlpha(0.95);
        scene.uiGroup.add(scene.giantWaspScoreText);

        utility.setDepthOfGroups(scene);

        scene.minimapCamera.ignore(scene.uiGroup);
    } catch(e) {
    	console.log('There was an error creating number of giant wasps leaderboard: ', e);
    }
}

export function createNumberOfQueenBeesLeaderboard(scene)
{
    try {
        console.log('Creating number of queens leaderboard.');
        var y = 90;

        tallyNumberOfQueenBeesScores(scene);

        // Create the score background.
        scene.queenBeeCountSprite = scene.add.sprite(0, y, 'sprites', 'queenCount.png')
            .setScrollFactor(0)
            .setOrigin(0)
            .setAlpha(0.5);
        scene.queenBeeCountSprite.x = window.innerWidth - scene.queenBeeCountSprite.width - 25;
        scene.uiGroup.add(scene.queenBeeCountSprite);
        // Create score text
        scene.queenBeeScoreText = scene.add.text(scene.queenBeeCountSprite.x + (scene.queenBeeCountSprite.width/2), scene.queenBeeCountSprite.y + 15, scene.numberOfQueenBeeBots+1)
            .setScrollFactor(0)
            .setOrigin(0.5)
            .setFontFamily('Arial')
            .setFontSize(24)
            .setColor('#F0DB87')
            .setAlpha(0.95);
        scene.uiGroup.add(scene.queenBeeScoreText);

        utility.setDepthOfGroups(scene);

        scene.minimapCamera.ignore(scene.uiGroup);
    } catch(e) {
    	console.log('There was an error creating number of queenBees leaderboard: ', e);
    }
}

export function tallyNumberOfWorkerScores(scene)
{
    try {
        scene.queenBees.forEach(function(queenBee, i)
        {
            queenBee.numberOfWorkers = 0;
            scene.workers.forEach(function(worker, j)
            {
                if (worker.username == queenBee.username &&
                    worker.workerSprite.active == true)
                {
                    queenBee.numberOfWorkers += 1;
                }
            });
        });

        if (scene.workerCountSprites[0])
        {
            updateLeaderboardEntriesWithNumberOfWorkers(scene);
        }
    } catch(e) {
    	console.log('There was an error tallying number of workers: ', e);
    }
}

export function tallyNumberOfYellowjacketsScores(scene)
{
    try {
        scene.numberOfYellowJackets = 0;
        scene.yellowJackets.forEach(function(yellowJacket, j)
        {
            if (yellowJacket.yellowJacketSprite.active == true)
            {
                scene.numberOfYellowJackets += 1;
            }
        });

        if (scene.yellowJacketCountSprite)
        {
            updateLeaderboardEntriesWithNumberOfYellowjackets(scene);
        }
    } catch(e) {
    	console.log('There was an error tallying number of yellow jackets: ', e);
    }
}

export function tallyNumberOfGiantWasps(scene)
{
    try {
        scene.numberOfGiantWasps = 0;
        scene.wasps.forEach(function(wasp, j)
        {
            if (wasp.waspSprite.active == true)
            {
                scene.numberOfGiantWasps += 1;
            }
        });

        if (scene.giantWaspCountSprite)
        {
            updateLeaderboardEntriesWithNumberOfGiantWasps(scene);
        }
    } catch(e) {
    	console.log('There was an error tallying giant wasps: ', e);
    }
}

export function tallyNumberOfQueenBeesScores(scene)
{
    try {
        scene.numberOfQueenBees = 0;
        scene.queenBees.forEach(function(queenBee, k)
        {
            if (queenBee.queenBeeSprite.active == true)
            {
                scene.numberOfQueenBees += 1;
            }
        });

        if (scene.queenBeeCountSprite)
        {
            updateLeaderboardEntry(scene, scene.numberOfQueenBees);
        }
    } catch(e) {
    	console.log('There was an error tallying queen bees: ', e);
    }
}

export function updateLeaderboardEntriesWithNumberOfWorkers(scene)
{
    try {
        scene.queenBees.forEach(function(queenBee, i)
        {
            if (queenBee.active)
            {
                scene.scoreTexts.forEach(function(scoreText, j)
                {
                    if (scoreText.username == queenBee.username)
                    {
                        scoreText.setText(queenBee.numberOfWorkers);
                        let isPlayerScore;
                        if (i == 0)
                        {
                            isPlayerScore = true;
                        } else {
                            isPlayerScore = false;
                        }
                        checkForWinOrLoss(scene, queenBee.numberOfWorkers, isPlayerScore);
                    }
                });
            }
        });
    } catch(e) {
    	console.log('There was an error updating leaderboard with numbers of workers: ', e);
    }
}

export function updateLeaderboardEntriesWithNumberOfYellowjackets(scene)
{
    try {
        if (scene.yellowJacketScoreText)
        {
            console.log('Yellowjacket scoretext did exist.', scene.yellowJacketScoreText);
            scene.yellowJacketScoreText.setText(scene.numberOfYellowJackets);
        } else {
            console.log("Yellowjacket scoretext didn't exist.");
        }
        checkForWinOrLoss(scene, scene.numberOfYellowJackets, null);
    } catch(e) {
    	console.log('There was an error updating leaderboard with number of yellow jackets: ', e);
    }
}

export function updateLeaderboardEntriesWithNumberOfGiantWasps(scene)
{
    try {
        if (scene.giantWaspScoreText)
        {
            console.log('GiantWaspScoreText did exist.', this.scoreText);
            scene.giantWaspScoreText.setText(scene.numberOfGiantWasps);
        } else {
            console.log("GiantWaspScoreText didn't exist.");
        }
        checkForWinOrLoss(scene, scene.numberOfGiantWasps, null);
    } catch(e) {
    	console.log('There was an error updating leaderboard with number of giant wasps: ', e);
    }
}

export function updateLeaderboardEntry(scene, score)
{
    try {
        if (scene.scoreText)
        {
            console.log('Scoretext did exist.', scene.scoreText);
            scene.scoreText.setText(score);
        } else {
            console.log("Scoretext didn't exist.");
        }
        checkForWinOrLoss(scene, score, null);
    } catch(e) {
    	console.log('There was an error updating leaderboard: ', e);
    }
}



// WEBPACK FOOTER //
// ./src/modules/challengeLevels.js